// Helpers utils and logic to resolve conditions based on
// previously answered data from the user
export const initAnswersUtils = (store) => ({
  ageRangeLevelsTypes: {
    ageRange_1: "ageRange1",
    ageRange_2: "ageRange2",
    ageRange_3: "ageRange3",
    ageRange_4: "ageRange4",
  },
  goalValuesTypes: {
    goalValue1: "goalValue1",
    goalValue2: "goalValue2",
    goalValue3: "goalValue3",
  },
  getUserGoal() {
    const goalValues = {
      valueLooking: this.goalValuesTypes.goalValue1,
      valueHealth: this.goalValuesTypes.goalValue2,
      valueHabits: this.goalValuesTypes.goalValue3,
    }
    let defaultGoalValue = goalValues.valueHealth

    try {
      defaultGoalValue = goalValues[store.values.yourGoal] // Override if has it

      if (!defaultGoalValue) {
        defaultGoalValue = goalValues.valueHealth
      }
    } catch (e) {
      console.error("[answerUtils] Error accessing goal value: ", e)
    }

    return defaultGoalValue
  },

  getGender() {
    let defaultGender = "female"

    try {
      defaultGender = store.values.gender || defaultGender // Override if has it
    } catch (e) {
      console.error("[asnwerUtils] Error accessing gender value: ", e)
    }

    return defaultGender
  },
  getAgeRange() {
    const defaultAgeRange = 'ageRange1'
    const storedAgeRange = this.ageRangeLevelsTypes[store.values.ageRange] || defaultAgeRange // Override if has it

    return storedAgeRange
  },
})
